// User Data class
import { Email } from './Email';

export class UserData {
    claims;

    email;
    markets;
    market;
    categories;
    category;
    brands;
    brand;

    hasAccess;

    constructor(token) {
        this.claims = {};
        this.processToken(token);

        this.email = new Email(token?.email);
        this.markets = Object.keys(this.claims).sort();
        this.market = null;
        this.categories = null;
        this.category = null;
        this.brands = null;
        this.brand = null;
    }

    setMarket(market) {
        if (this.market && this.market === market) return false;
        this.market = this.markets.includes(market)
            ? market
            : this.markets[0] || null;
        this.categories = Object.keys(this.claims[this.market]);
        this.category = this.categories[0];
        this.brands = this.claims[this.market][this.category];
        this.brand = this.brands[0];
        return true;
    }

    setCategory(category) {
        if (this.category && this.category === category) return false;
        this.category = this.categories.includes(category)
            ? category
            : this.categories[0] || null;

        this.brands = this.claims[this.market][this.category];
        this.brand = this.brands[0];

        return true;
    }

    setBrand(brand) {
        if (this.brand && this.brand === brand) return false;
        this.brand = this.brands.includes(brand)
            ? brand
            : this.brands[0] || null;

        return true;
    }

    processToken(token) {
        for (const key in token) {
            if (key.startsWith('APP:')) {
                const [category, market] = key.split(':');
                const brands = token[key].split(',');

                if (!this.claims[market]) {
                    this.claims[market] = {};
                }

                if (!this.claims[market][category]) {
                    this.claims[market][category] = [];
                }

                this.claims[market][category].push(...brands);
            }
        }
        this.hasAccess = Object.keys(this.claims).length !== 0;
    }
}
